import { render } from "./Configuration.vue?vue&type=template&id=048ea1a6&scoped=true"
import script from "./Configuration.vue?vue&type=script&lang=ts"
export * from "./Configuration.vue?vue&type=script&lang=ts"

import "./Configuration.vue?vue&type=style&index=0&id=048ea1a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-048ea1a6"

export default script